/* import __COLOCATED_TEMPLATE__ from './email-group-user-chooser-row.hbs.js'; */
import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const EmailGroupUserChooserRow = dt7948.c(class EmailGroupUserChooserRow extends SelectKitRowComponent {}, [classNames("email-group-user-chooser-row")]);
export default EmailGroupUserChooserRow;